import { supabase } from "@/integrations/supabase/client";

/**
 * Get the current user's auth token from Supabase
 * 
 * @returns Promise resolving to the auth token or null if not authenticated
 */
export async function getAuthToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token || null;
}

/**
 * Centralized signOut function that always uses scope: 'local' to ensure
 * only the current device/session is signed out, not all sessions across devices.
 * 
 * @returns Promise with the result of the sign out operation
 */
export async function signOut() {
  return await supabase.auth.signOut({ scope: 'local' });
} 